module.exports = __webpack_public_path__ + "7118d02206c50c01c90a6377b2635007.svg";